export interface Video {
  id: number;
  name: string;
  title: string;
  description: string;
  thumbnailUrl: string;
  contentUrl: string;
  duration: number;
  publishedAt: string;
  viewCount: number;
  likeCount: number;
  dislikeCount: number;
  commentCount: number;
  muted: boolean;
  game?: string;
  viewabilityTracking: boolean;
  processed: boolean;
  status: "pending" | "active" | "deleted" | "src_issue";
  chatId?: number;
  profileId: number;
  languageCodeId: number;
  createdAt: string;
  updatedAt: string;
}

export function validateVideo(video: Omit<Video, "id" | "createdAt" | "updatedAt">) {
  const errors: Partial<Record<keyof Video, string>> = {};

  if (!video?.name) {
    errors.name = "Name is required";
  } else if (video.name.length > 255) {
    errors.name = "Name is too long";
  }

  if (!video?.title) {
    errors.title = "Title is required";
  } else if (video.title.length > 255) {
    errors.title = "Title is too long";
  }

  if (!video?.description) {
    errors.description = "Description is required";
  }

  if (!video?.thumbnailUrl) {
    errors.thumbnailUrl = "Thumbnail URL is required";
  } else if (video.thumbnailUrl.length > 255) {
    errors.thumbnailUrl = "Thumbnail URL is too long";
  }

  if (!video?.contentUrl) {
    errors.contentUrl = "Content URL is required";
  } else if (video.contentUrl.length > 255) {
    errors.contentUrl = "Content URL is too long";
  }

  if (!video?.publishedAt) {
    errors.publishedAt = "Published At is required";
  }

  return errors;
}
